/**
 * Mutations for the [target_access_permissions store]{link module:store/target_access_permissions}
 *
 * @module store/target_access_permissions/mutations
 */

import { TargetAccessPermission } from '@/store/modules/target_access_permissions'

export function DELETE_TIME_RANGES(state, { deleteTimeRangeIndexes, permissionId }) {
  if (!state.permissions[permissionId]?.timeRanges) return

  state.permissions[permissionId].timeRanges = state.permissions[permissionId].timeRanges.filter(
    (_, i) => !deleteTimeRangeIndexes.includes(i)
  )
}
export function RESET_STORE(state) {
  state.fullPermissionUserIds = []
  state.restrictedPermissionUserIds = []
  state.permissions = {}
}
export function SET_FULL_PERMISSION_USER_IDS(state, { fullPermissionUserIds }) {
  state.fullPermissionUserIds = fullPermissionUserIds
}
export function SET_RESTRICTED_PERMISSION_USER_IDS(state, { restrictedPermissionUserIds }) {
  state.restrictedPermissionUserIds = restrictedPermissionUserIds
}
export function SET_TARGET_ACCESS_PERMISSION(state, { targetAccessPermission }) {
  if (!(targetAccessPermission instanceof TargetAccessPermission)) return

  state.permissions[targetAccessPermission.id] = targetAccessPermission
}
